<div>
  <ig-date-time-picker
    *ngIf="controls.controls.length > 0"
    [startFormControl]="controls.controls[0].get('startTime')"
    [endFormControl]="controls.controls[0].get('endTime')"
    [isAllDay]="controls.controls[0].get('isAllDay')?.value"
    [isEndAllDay]="controls.controls[0].get('isEndAllDay')?.value"
    [endDateInitOnly]="endDateInitOnly"
    class="w-full" [timezoneFormatter]="timezoneFormatter"
    (change)="datetimePickerChange()"
    (allDayChange)="onAllDayChange(0, $event)"
    (endAllDayChange)="onEndAllDayChange(0, $event)">
  </ig-date-time-picker>

  <div class="text-gray-500 text-xs relative -top-4">
    {{ tzNameByFormatter }}
  </div>
  <div>
    <ig-select #select [(ngModel)]="frequencyItems" label="Frequency" place="top" (onOpen)="setFrequencyDropdown()"
      (itemSelected)="frequencySourceChange($event)">
    </ig-select>
    <p *ngIf="message" class="text-red-500 text-sm text-left -translate-y-4 !my-0">{{ message }}</p>
    <div *ngIf="totalTimes && frequency !== 'custom' && frequency !== 'event'" [matTooltip]="getSelectedTimesTooltip()"
      class="text-gray-500 text-sm text-left mb-5 flex items-center gap-2">
      <span>
        <b>{{ totalTimes.split("Dates")[0] }} Date{{ totalTimes.split("Dates")[0] > 1 ? 's' : '' }}</b>
      </span>
      <span>·</span>
      <span>
        {{ totalTimes.split("Dates")[1] }}
      </span>
    </div>

    <!-- ── FLAT LIST: ≤ GROUP_SIZE dates ── -->
    <div *ngIf="selectedTimes.length > 0 && selectedTimes.length <= GROUP_SIZE"
      class="mb-6 rounded-xl border border-gray-200 overflow-hidden bg-white shadow-sm">

      <div class="px-4 py-2.5 bg-gray-50 border-b border-gray-200 flex items-center justify-between">
        <div class="flex items-center gap-2">
          <span class="text-xs font-semibold text-gray-600 uppercase tracking-wide">All Dates</span>
          <span class="text-xs text-gray-400 font-medium">· {{ selectedTimes.length }} dates</span>
        </div>
        <button *ngIf="!customizeMode"
          class="flex items-center gap-1 text-xs text-purple-600 border border-purple-400 rounded-md px-2.5 py-1 hover:bg-purple-50 transition-colors duration-150"
          (click)="enterCustomizeMode()">
          <mat-icon class="!text-sm !w-4 !h-4 leading-4">edit</mat-icon>
          Customize
        </button>
        <button *ngIf="customizeMode"
          class="flex items-center gap-1 text-xs text-white bg-purple-500 rounded-md px-2.5 py-1 hover:bg-purple-600 transition-colors duration-150"
          (click)="exitCustomizeMode()">
          <mat-icon class="!text-sm !w-4 !h-4 leading-4">check</mat-icon>
          Done
        </button>
      </div>

      <div *ngFor="let time of selectedTimes; let i = index; trackBy: trackByIndex">
        <div *ngIf="editingIndex === i" class="px-4 py-3 bg-purple-50 border-b border-purple-100">
          <ig-date-time-picker
            [startFormControl]="editingStartControl"
            [endFormControl]="editingEndControl"
            [isAllDay]="editingFormGroup?.get('isAllDay')?.value"
            [isEndAllDay]="editingFormGroup?.get('isEndAllDay')?.value"
            class="w-full" [timezoneFormatter]="timezoneFormatter"
            (allDayChange)="setEditingAllDay($event)" (endAllDayChange)="setEditingEndAllDay($event)">
          </ig-date-time-picker>
          <div class="flex gap-2 mt-3 justify-end">
            <button mat-stroked-button class="!text-xs !h-8 !min-w-0 !px-4" (click)="cancelEdit()">Cancel</button>
            <button mat-flat-button color="primary" class="!text-xs !h-8 !min-w-0 !px-4" (click)="saveEdit(i)">Save</button>
          </div>
        </div>
        <div *ngIf="editingIndex !== i"
          class="flex items-center justify-between px-4 py-2.5 border-b border-gray-100 last:border-0 hover:bg-gray-50 transition-colors duration-100">
          <div class="flex items-center gap-3 min-w-0">
            <span class="flex-shrink-0 w-6 h-6 rounded-full bg-gray-100 text-gray-500 text-[10px] font-bold flex items-center justify-center">
              {{ i + 1 }}
            </span>
            <span class="text-sm text-gray-700 truncate">{{ formattedTimes[i] }}</span>
          </div>
          <div *ngIf="customizeMode && !isAddingNewEntry" class="flex items-center gap-1 flex-shrink-0">
            <button class="w-7 h-7 rounded-full flex items-center justify-center hover:bg-purple-100 transition-colors duration-150"
              (click)="startEdit(i)" matTooltip="Edit this date">
              <mat-icon class="!text-base !w-4 !h-4 text-purple-500 !leading-4">edit</mat-icon>
            </button>
            <button class="w-7 h-7 rounded-full flex items-center justify-center hover:bg-red-100 transition-colors duration-150"
              (click)="deleteTime(i)" matTooltip="Delete this date">
              <mat-icon class="!text-base !w-4 !h-4 text-red-400 !leading-4">delete</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- ── CAROUSEL: > GROUP_SIZE dates ── -->
    <div *ngIf="selectedTimes.length > GROUP_SIZE" class="mb-6">

      <div class="flex gap-3 overflow-x-auto pb-3 snap-x snap-mandatory"
        style="scrollbar-width: thin; scrollbar-color: #e5e7eb transparent;">
        <div *ngFor="let group of groupedTimes; let gi = index; trackBy: trackByIndex"
          class="flex-shrink-0 snap-start cursor-pointer rounded-xl border-2 px-4 py-3 w-[148px] transition-all duration-200 select-none"
          [ngClass]="activeGroupIndex === gi
            ? 'border-purple-500 bg-purple-50 shadow-md'
            : 'border-gray-200 bg-white hover:border-purple-500 hover:shadow-sm'"
          (click)="toggleGroup(gi)">
          <div class="text-[11px] font-semibold text-gray-700 leading-snug mb-2">{{ group.label }}</div>
          <div class="text-2xl font-bold"
            [ngClass]="activeGroupIndex === gi ? 'text-purple-600' : 'text-gray-400'">
            {{ group.times.length }}
          </div>
          <div class="text-[10px] text-gray-400 uppercase tracking-wide">dates</div>
          <div class="mt-2 flex justify-center">
            <mat-icon class="!text-sm !w-4 !h-4 leading-4"
              [ngClass]="activeGroupIndex === gi ? 'text-purple-500' : 'text-gray-300'">
              {{ activeGroupIndex === gi ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
            </mat-icon>
          </div>
        </div>
      </div>

      <div *ngIf="activeGroupIndex !== null"
        class="mt-2 rounded-xl border border-gray-200 overflow-hidden bg-white shadow-sm">

        <div class="px-4 py-2.5 bg-gray-50 border-b border-gray-200 flex items-center justify-between">
          <div class="flex items-center gap-2">
            <span class="text-xs font-semibold text-gray-600 uppercase tracking-wide">
              {{ groupedTimes[activeGroupIndex].label }}
            </span>
            <span class="text-xs text-gray-400 font-medium">
              · {{ groupedTimes[activeGroupIndex].times.length }} dates
            </span>
          </div>
          <button *ngIf="!customizeMode"
            class="flex items-center gap-1 text-xs text-purple-600 border border-purple-400 rounded-md px-2.5 py-1 hover:bg-purple-50 transition-colors duration-150"
            (click)="enterCustomizeMode()">
            <mat-icon class="!text-sm !w-4 !h-4 leading-4">edit</mat-icon>
            Customize
          </button>
          <button *ngIf="customizeMode"
            class="flex items-center gap-1 text-xs text-white bg-purple-500 rounded-md px-2.5 py-1 hover:bg-purple-600 transition-colors duration-150"
            (click)="exitCustomizeMode()">
            <mat-icon class="!text-sm !w-4 !h-4 leading-4">check</mat-icon>
            Done
          </button>
        </div>

        <div *ngFor="let time of groupedTimes[activeGroupIndex].times; let i = index; trackBy: trackByIndex">
          <div *ngIf="editingIndex === groupedTimes[activeGroupIndex].offset + i"
            class="px-4 py-3 bg-purple-50 border-b border-purple-100">
            <ig-date-time-picker
              [startFormControl]="editingStartControl"
              [endFormControl]="editingEndControl"
              [isAllDay]="editingFormGroup?.get('isAllDay')?.value"
              [isEndAllDay]="editingFormGroup?.get('isEndAllDay')?.value"
              class="w-full" [timezoneFormatter]="timezoneFormatter"
              (allDayChange)="setEditingAllDay($event)" (endAllDayChange)="setEditingEndAllDay($event)">
            </ig-date-time-picker>
            <div class="flex gap-2 mt-3 justify-end">
              <button mat-stroked-button class="!text-xs !h-8 !min-w-0 !px-4" (click)="cancelEdit()">Cancel</button>
              <button mat-flat-button color="primary" class="!text-xs !h-8 !min-w-0 !px-4"
                (click)="saveEdit(groupedTimes[activeGroupIndex].offset + i)">Save</button>
            </div>
          </div>
          <div *ngIf="editingIndex !== groupedTimes[activeGroupIndex].offset + i"
            class="flex items-center justify-between px-4 py-2.5 border-b border-gray-100 last:border-0 hover:bg-gray-50 transition-colors duration-100">
            <div class="flex items-center gap-3 min-w-0">
              <span class="flex-shrink-0 w-6 h-6 rounded-full bg-gray-100 text-gray-500 text-[10px] font-bold flex items-center justify-center">
                {{ groupedTimes[activeGroupIndex].offset + i + 1 }}
              </span>
              <span class="text-sm text-gray-700 truncate">{{ formattedTimes[groupedTimes[activeGroupIndex].offset + i] }}</span>
            </div>
            <div *ngIf="customizeMode && !isAddingNewEntry" class="flex items-center gap-1 flex-shrink-0">
              <button class="w-7 h-7 rounded-full flex items-center justify-center hover:bg-purple-100 transition-colors duration-150"
                (click)="startEdit(groupedTimes[activeGroupIndex].offset + i)"
                matTooltip="Edit this date">
                <mat-icon class="!text-base !w-4 !h-4 text-purple-500 !leading-4">edit</mat-icon>
              </button>
              <button class="w-7 h-7 rounded-full flex items-center justify-center hover:bg-red-100 transition-colors duration-150"
                (click)="deleteTime(groupedTimes[activeGroupIndex].offset + i)"
                matTooltip="Delete this date">
                <mat-icon class="!text-base !w-4 !h-4 text-red-400 !leading-4">delete</mat-icon>
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div *ngIf="isAddingNewEntry" class="mb-4 rounded-xl border border-purple-200 bg-purple-50 px-4 py-3">
      <ig-date-time-picker
        [startFormControl]="editingStartControl"
        [endFormControl]="editingEndControl"
        [isAllDay]="editingFormGroup?.get('isAllDay')?.value"
        [isEndAllDay]="editingFormGroup?.get('isEndAllDay')?.value"
        class="w-full" [timezoneFormatter]="timezoneFormatter"
        (allDayChange)="setEditingAllDay($event)" (endAllDayChange)="setEditingEndAllDay($event)">
      </ig-date-time-picker>
      <div class="flex gap-2 mt-3 justify-end">
        <button mat-stroked-button class="!text-xs !h-8 !min-w-0 !px-4" (click)="cancelEdit()">Cancel</button>
        <button mat-flat-button color="primary" class="!text-xs !h-8 !min-w-0 !px-4" (click)="saveEdit(-1)">Save</button>
      </div>
    </div>

    <button *ngIf="(frequency === 'custom' || customizeMode) && !isAddingNewEntry"
      class="flex items-center justify-center gap-1.5 text-sm text-purple-600 border border-dashed border-purple-400 rounded-xl px-4 py-2.5 w-full hover:bg-purple-50 transition-colors duration-150 mb-2"
      (click)="addTime()">
      <mat-icon class="!text-base !w-4 !h-4 !leading-none flex items-center">add</mat-icon>
      Add Date
    </button>


  </div>
</div>